<template>
  <Alert v-if="showAlert && isOnOldEditor && hasNewUploads && !hasAlert && !isInMobileApp" tone="neutral" :dismissable="true" class="alert-neutral">
    <span v-html="msg"></span>
  </Alert>
</template>

<script setup lang="ts">
import "@/src/i18n";
import { ref } from "vue";
import emitter from "@/modules/event_bus";
import User from "@/modules/user";
import { Alert } from "prism";

const hasNewUploads = ref<boolean>(false);
const isOnOldEditor = ref<boolean>(false);
const hasAlert = ref<boolean>(false);
const showAlert = ref<boolean>(false);
const isInMobileApp = ref<boolean>(false);

const path = User.newEditorUrl();
const msg = window.I18n.t("editor.new_images_present_html", { link: path + "?showNewUploads=true", count: User.numberOfNewUploads() });

const checkAlerts = () => {
  hasAlert.value = document.querySelector("#flashes .alert-neutral") !== null;
};

const checkNewUploads = () => {
  hasNewUploads.value = User.hasNewUploads();
};

const checkEditorPage = () => {
  isOnOldEditor.value = document.querySelector(".upload-page") !== null;
};

emitter.on("oldEditorMounted", () => {
  showAlert.value = true;
  isInMobileApp.value = User.mobileApp();
  checkAlerts();
  checkNewUploads();
  checkEditorPage();
});
</script>
